(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'booleanControl',
            [
                'CHROME',
                BooleanControlFactory
            ]
        );

    // Factory Method
    function BooleanControlFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.PROJECT.CONTROL.BOOLEAN + CHROME.POSTFIX
        };

    }
})();



